module.exports = __webpack_public_path__ + "media/Video 107.ca794186.mp4";